import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TagsInput from 'react-tagsinput';
import { Field, reduxForm } from 'redux-form';
import { Col, Row, FormGroup } from 'reactstrap';
import Button from 'components/buttons/Button';
import RenderTag from 'components/forms/RenderTag';
import { withStyles } from '@material-ui/styles';

import { emailTagsValidator } from 'utils/validators';
import RenderSwitchInput from 'components/forms/RenderSwitchInput';
import RenderSelectInput from 'components/forms/RenderSelectInput';
import Error from 'components/forms/Error';
import { FORWARD_EMAIL_TEMPLATE_OPTIONS } from 'constants/account';
import { isPRVoltOrganization } from 'utils/organization';
import { secondary0 } from '../../../../themes/colors';


const styles = theme => ({
  label: {
    color: theme.palette.secondary.text,
    fontSize: '0.875rem',
    marginTop: '0.875rem',
  },
  tagsInput: {
    display: 'block',
    width: '100%',
    height: 'auto',
    minHeight: '3rem',
    marginTop: '0.375rem',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    lineHeight: '1.5',
    color: '#495057',
    backgroundColor: secondary0,
    backgroundClip: 'padding-box',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
  },
  forwardLeadsToSection: {
    alignItems: 'center',
  },
});

const LeadsHandlingForm = (props) => {
  const { classes, account } = props;
  return (
    <form onSubmit={props.handleSubmit}>
      <Row>
        <Col lg={6} xl={5}>
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label
              className={`${classes.label} col-sm-5`}
              htmlFor="acceptsSponsorships"
            >
              Consider sponsorship replies as leads
            </label>
            <Col sm={7} className="mt-1">
              <Field
                maxLength="255"
                className="primary"
                id="acceptsSponsorships"
                name="acceptsSponsorships"
                component={RenderSwitchInput}
              />
            </Col>
          </FormGroup>

          <FormGroup row className={classes.forwardLeadsToSection}>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label
              className={`${classes.label} col-sm-5`}
              htmlFor="forwardResponseEmailsTo"
            >
              Forward leads (when categorized) to
            </label>
            <Col sm={7}>
              <Field
                name="forwardResponseEmailsTo"
                validate={[emailTagsValidator]}
                component={propsCus => (
                  <React.Fragment>
                    <TagsInput
                      addOnBlur
                      addKeys={['Enter', 'Tab', ' ']}
                      className={classes.tagsInput}
                      renderTag={RenderTag}
                      inputProps={{
                        className: 'react-tagsinput-input',
                        placeholder: 'Add email',
                      }}
                      value={propsCus.input.value || []}
                      onChange={propsCus.input.onChange}
                      onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
                    />
                    {propsCus.meta.touched &&
                      propsCus.meta.error && <Error error={propsCus.meta.error} />}
                  </React.Fragment>
                )}
              />
            </Col>
          </FormGroup>
          {isPRVoltOrganization(account.organization) && false && (
            <FormGroup row>
              {/* eslint-disable jsx-a11y/label-has-for */}
              <label
                className={`${classes.label} col-sm-5`}
                htmlFor="forwardEmailTemplate"
              >
                Forward Email Template
              </label>
              <Col sm={7} className="mt-1">
                <Field
                  maxLength="255"
                  className="primary"
                  id="forwardEmailTemplate"
                  name="forwardEmailTemplate"
                  component={RenderSelectInput}
                  options={FORWARD_EMAIL_TEMPLATE_OPTIONS}
                />
              </Col>
            </FormGroup>
          )}
        </Col>
      </Row>
      <Button
        color="primary"
        variant="outlined"
        type="submit"
        disabled={props.pristine || props.submitting}
      >
        Save
      </Button>
    </form>
  );
};


LeadsHandlingForm.propTypes = {
  classes: PropTypes.element.isRequired,
  account: PropTypes.shape({}).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};


LeadsHandlingForm.defaultProps = {
  submitting: false,
  pristine: true,
};


export default compose(
  withStyles(styles),
  connect(
    state => ({
      account: state.account,
      initialValues: {
        acceptsSponsorships: state.account.accepts_sponsorships,
        forwardResponseEmailsTo: state.account.response_email_forwards ?
          state.account.response_email_forwards.split(',')
          : [],
        forwardEmailTemplate: FORWARD_EMAIL_TEMPLATE_OPTIONS.find(e => (
          e.value === state.account.forward_email_template
        )),
      },
    }),
    { },
  ),
  reduxForm({
    form: 'accountLeadsHandlingForm',
    enableReinitialize: true,
  }),
)(LeadsHandlingForm);
